import { useState, useMemo } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@/components'

import { twMerge } from '@/styles/tailwindMergeConfig'
import { useGetDemand } from '@/hooks/useGetDemand'
import { ReportDialog } from './ReportDialog'
import { useReportOptions } from '@/hooks/reports/useReportOptions'
import { useUserFromToken } from '@/hooks/useUserFromToken'

export function Header({ action }: { action: 'refuse' | 'report' }) {
  const { data } = useGetDemand()
  const { userId } = useUserFromToken()
  const [isOpenReportDialog, setIsOpenReportDialog] = useState(false)
  const { reportOptions } = useReportOptions()

  const reportData = useMemo(() => {
    const baseData = {
      created_by: userId,
      emails: reportOptions.notifiedPeople.map((person) => person.email),
      issues: reportOptions.reasons.map((reason) => reason.key),
      comments: reportOptions.comment
    }
    if (action === 'refuse') {
      return {
        ...baseData,
        resolution: 'refuse'
      }
    }
    return baseData
  }, [userId, reportOptions, action])

  if (action !== 'refuse' && action !== 'report') return null

  return (
    <header className="flex w-full max-w-screen-xl items-start justify-between gap-8 pt-3">
      <div className="flex w-0 flex-1">
        <h1 className="text-headlineSmall text-cromai-m3-sys-light-on-background dark:text-cromai-m3-sys-dark-on-background">
          {data?.demandName}
        </h1>
      </div>

      <div className="flex gap-4">
        <div className={twMerge('hidden gap-4 lg:flex')}>
          {data && (
            <>
              <Link to={`/demands/${data.id}`}>
                <Button variant="outlined" size="sm">
                  {action === 'refuse' ? 'Cancelar Recusa' : 'Cancelar Reporte'}
                </Button>
              </Link>

              <Button
                size="sm"
                onClick={() => setIsOpenReportDialog(true)}
                disabled={reportOptions.reasons.length === 0}
              >
                {action === 'refuse' ? 'Recusar Demanda' : 'Reportar Demanda'}
              </Button>

              <ReportDialog
                demandId={data.id}
                demandName={data.demandName}
                reportData={reportData}
                isOpen={isOpenReportDialog}
                setIsOpen={setIsOpenReportDialog}
                action={action}
              />
            </>
          )}
        </div>
      </div>
    </header>
  )
}
